import PropTypes from "prop-types"
import React, { useMemo, useState } from "react"
import { withTranslation } from "react-i18next"
import { Box } from "@mui/material"
import ListDataTable from "../../components/Common/list-data-table"
import { apiBuscarVendasItensInsumos } from "../../helpers/backend_helper"
import { describeDateTime, describeMoney } from "../../helpers/utils"
import {
    DateColumnFilter,
    describeQuantidade,
    describeSimNao,
    EmptyRowsMessage,
    opcoesSimNao,
    opcoesSituacao,
    SituacaoBadge
} from "./movimento-vendas-detalhe-cells"

/**
 * Insumos do item selecionado. A consulta é escopada pelas chaves de origem do item
 * (empresa, venda, sequência e item) recebidas em filters.
 */
const MovimentoVendasInsumosTable = props => {

    const { filters, t } = props
    const [data, setData] = useState([])

    const colunas = useMemo(() => [
        { header: t("movimentovendas.insumos.seq"), accessorKey: "Seq", id: "Seq", size: 130 },
        { header: t("movimentovendas.insumos.item"), accessorKey: "Item", id: "Item", size: 120 },
        { header: t("movimentovendas.insumos.codigo"), accessorKey: "Codigo", id: "Codigo", size: 160 },
        {
            header: t("movimentovendas.insumos.qtd"), accessorKey: "Qtd", id: "Qtd", size: 130,
            Cell: ({ cell }) => (<Box sx={ { display: "block", textAlign: "right" } }>{ describeQuantidade(cell?.getValue()) }</Box>)
        },
        { header: t("movimentovendas.insumos.altfunc"), accessorKey: "AltFunc", id: "AltFunc", size: 140 },
        {
            header: t("movimentovendas.insumos.altdata"), accessorKey: "AltData", id: "AltData", size: 170,
            Cell: ({ cell }) => describeDateTime(cell?.getValue()), sortingFn: "datetime",
            Filter: DateColumnFilter
        },
        {
            header: t("movimentovendas.insumos.preco"), accessorKey: "Preco", id: "Preco", size: 130,
            Cell: ({ cell }) => (<Box sx={ { display: "block", textAlign: "right" } }>{ describeMoney(cell?.getValue()) }</Box>)
        },
        {
            header: t("movimentovendas.insumos.promocao"), accessorKey: "Promocao", id: "Promocao", size: 140,
            Cell: ({ cell }) => (<Box sx={ { display: "block", textAlign: "right" } }>{ describeMoney(cell?.getValue()) }</Box>)
        },
        {
            header: t("movimentovendas.insumos.conteudo"), accessorKey: "Conteudo", id: "Conteudo", size: 130,
            Cell: ({ cell }) => describeSimNao(cell?.getValue(), t),
            filterSelectOptions: opcoesSimNao(t), filterVariant: "select"
        },
        {
            header: t("movimentovendas.insumos.troca"), accessorKey: "Troca", id: "Troca", size: 120,
            Cell: ({ cell }) => describeSimNao(cell?.getValue(), t),
            filterSelectOptions: opcoesSimNao(t), filterVariant: "select"
        },
        { header: t("movimentovendas.insumos.opcional"), accessorKey: "Opcional", id: "Opcional", size: 130 },
        {
            header: t("movimentovendas.insumos.quantacres"), accessorKey: "Quant_Acres", id: "Quant_Acres", size: 160,
            Cell: ({ cell }) => (<Box sx={ { display: "block", textAlign: "right" } }>{ describeQuantidade(cell?.getValue()) }</Box>)
        },
        {
            header: t("movimentovendas.insumos.condicao"), accessorKey: "Condicao", id: "Condicao", size: 130,
            Cell: ({ cell }) => describeSimNao(cell?.getValue(), t),
            filterSelectOptions: opcoesSimNao(t), filterVariant: "select"
        },
        {
            header: t("movimentovendas.insumos.viagem"), accessorKey: "Viagem", id: "Viagem", size: 120,
            Cell: ({ cell }) => describeSimNao(cell?.getValue(), t),
            filterSelectOptions: opcoesSimNao(t), filterVariant: "select"
        },
        {
            header: t("movimentovendas.insumos.status"), accessorKey: "Status", id: "Status", size: 150,
            Cell: ({ cell }) => (<SituacaoBadge situacao={ cell?.getValue() } t={ t } />),
            filterSelectOptions: opcoesSituacao(t), filterVariant: "multi-select"
        },
        { header: t("movimentovendas.insumos.idarea"), accessorKey: "idArea", id: "idArea", size: 150 }
    ], [t])

    return (
        <ListDataTable
            searchFn={ params => apiBuscarVendasItensInsumos(params) }
            advancedFilters={ filters }
            resetPageOnFiltersChange={ true }
            columns={ colunas }
            data={ data }
            setData={ setData }
            defaultSorting={ [{ id: "Codigo", desc: false }] }
            renderEmptyRowsFallback={ () => (<EmptyRowsMessage mensagem={ t("movimentovendas.insumos.vazio") } />) }
        />
    )
}

MovimentoVendasInsumosTable.propTypes = {
    filters: PropTypes.array,
    t: PropTypes.func
}

export default withTranslation()(MovimentoVendasInsumosTable)
